import { render, staticRenderFns } from "./Citations.vue?vue&type=template&id=51f778cc&"
import script from "./Citations.vue?vue&type=script&lang=js&"
export * from "./Citations.vue?vue&type=script&lang=js&"
import style0 from "./Citations.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports